export default "__VITE_ASSET__CSx3IS_d__"